import { atom } from "jotai";

export const publicacionesAtom = atom([]);
// export const tipoAbsentismoSeleccionadoAtom = atom(undefined);
// export const reglaSeleccionadaAtom = atom(undefined);

// export const openDrawerConfigurarReglaAtom = atom(false);
// export const openDrawerConfigurarDetalleReglaAtom = atom(false);